module.exports = {"ENTER_INV_KEY":"Please enter your invitation key or UAS serial number (1587...) below","INVITATION_KEY_GENERIC_ERROR":"Something went wrong. Please reload and try again!","INVITATION_KEY_ALREADY_REDEEMED":"Error – Invitation Key or UAS serial number is already in use. Please contact senseFly Technical Support for help:<br/><a href=\"mailto:support@sensefly.com\">support@sensefly.com</a>","PRODUCT_NOT_FOUND":"Product not found. Please reload and try again!","PRODUCT_NOT_SOLD":"Error – Missing customer purchase information.","REGISTER_NEW_PROD":"Register a new product"}


//////////////////
// WEBPACK FOOTER
// ./src/static/messages.json
// module id = JHje
// module chunks = 1